// core/context-manager.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RecommendationContext } from '../core/types';

@Injectable({ providedIn: 'root' })
export class ContextManager {
  private context = new BehaviorSubject<RecommendationContext>({
    currentStep: 'category',
    userQuery: '',
    extractedFeatures: [],
    loadingState: 'idle'
  });

  currentContext$ = this.context.asObservable();

  getCurrentContext(): RecommendationContext {
    return this.context.value;
  }

  updateContext(update: Partial<RecommendationContext>) {
    this.context.next({ ...this.context.value, ...update });
  }

  resetContext() {
    this.context.next({
        currentStep: 'category',
        userQuery: '',
        extractedFeatures: [],
        loadingState: 'idle'
    });
  }
}